import gql from "/vendor/graphql-tag";
import {
  useApolloClient,
  useQuery,
  useRouter,
} from "/lib/component/util";
import { parseStringParam } from "/lib/util/params";

// const allEntitiesChecksQuery = gql`
//   query AllEntitiesChecksQuery(
//     $limit: Int
//   ) {
//     viewer {
// 			namespaces {
// 				name
// 				entities(limit: $limit) {
// 					nodes {
// 						name
// 						events {
// 							check {
// 								name
// 								output
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
//   }
// `;

const namespaceChecksQuery = gql`
  query AllEntitiesChecksQuery(
    $namespace: String!,
    $limit: Int
  ) {
    namespace(name: $namespace) {
      id
      name
      entities(limit: $limit) {
        nodes {
          id
          name
          events {
            id
            check {
              status
              name
              output
            }
          }
        }
      }
    }
  }
`;

const useMapData = () => {
  const client = useApolloClient();
  const router = useRouter();
  const params = router.match.params;
  const variables = {
    namespace: parseStringParam(params.namespace, ""),
    filters: ["is_silenced:false", "fieldSelector: event.check.status notin [\"0\"]"],
    order: "LASTOK",
    limit: 250,
    offset: 0,
  };

  return useQuery({
    client,
    query: namespaceChecksQuery,
    variables,
    fetchPolicy: "cache-and-network",
    // pollInterval: 5000, // change this to your preferred polling interval
  });
}

export default useMapData;